import { env, loadConfig } from '@/lib/config';

const runtimeEnv = import.meta.env ?? {};

export const appVersion: string = typeof APP_VERSION === 'undefined' ? 'test' : APP_VERSION;
export type BillingCustomerType = 'store' | 'supplier' | 'retailer';

const allBillingCustomerTypes = [
  'store',
  'supplier',
  'retailer',
] as const satisfies readonly BillingCustomerType[];

const config = loadConfig(runtimeEnv, {
  countryCodes: env.csv('VITE_COUNTRY_CODES'),
  currencyCodes: env.csv('VITE_CURRENCY_CODES'),
  enableVersionReloadByDefault: env.notFalse('VITE_ENABLE_VERSION_RELOAD'),
  simulateVersionUpdate: env.boolean('VITE_SIMULATE_VERSION_UPDATE'),
  enableSkuSearchFacets: env.boolean('VITE_ENABLE_SKU_SEARCH_FACETS'),
  enableSupplierProductLists: env.boolean('VITE_ENABLE_SUPPLIER_PRODUCT_LISTS'),
  enabledBillingCustomerTypes: env.delimitedEnumValues(
    'VITE_BILLING_CUSTOMER_TYPES_ENABLED',
    allBillingCustomerTypes,
    { defaultValue: 'supplier' },
  ),
  apiBaseUrl: env.string('VITE_API_BASE_URL'),
  stripePublishableKey: env.string('VITE_STRIPE_PUBLISHABLE_KEY'),
});

export const countryCodes = config.countryCodes;
export const currencyCodes = config.currencyCodes;
export const enableVersionReloadByDefault = config.enableVersionReloadByDefault;
export const simulateVersionUpdate = config.simulateVersionUpdate;
export const enableSkuSearchFacets = config.enableSkuSearchFacets;
export const enableSupplierProductLists = config.enableSupplierProductLists;

export const isBillingEnabledFor = (customerType: BillingCustomerType): boolean =>
  config.enabledBillingCustomerTypes.includes(customerType);

interface Language {
  name: string;
  code: string;
  flag: string;
  isSupported?: boolean;
}

export const languages: Language[] = [
  { name: 'English', code: 'en', flag: '/flags/US.svg', isSupported: true },
  { name: 'Thai', code: 'th', flag: '/flags/TH.svg', isSupported: false },
  { name: 'Indonesian', code: 'id', flag: '/flags/ID.svg', isSupported: false },
  { name: 'Filipino', code: 'ph', flag: '/flags/PH.svg', isSupported: false },
];

interface Currency {
  name: string;
  code: string;
}

export const currencies: Currency[] = [
  { name: 'Singapore Dollar', code: 'SGD' },
  { name: 'US Dollar', code: 'USD' },
  { name: 'Philippine Peso', code: 'PHP' },
  { name: 'Indonesian Rupiah', code: 'IDR' },
  { name: 'Thai Baht', code: 'THB' },
];

export const apiBaseUrl = config.apiBaseUrl;
export const stripePublishableKey = config.stripePublishableKey.trim() || null;
